import type { FormField } from "@/components/website-builder/blocks/types"
import { ContactFormView } from "@/components/website-builder/ContactFormView"
import type { BlockComponentProps } from "./shared"

export function ContactBlock({ content, org, resolved, sectionId }: BlockComponentProps) {
  const contactFields = (content?.fields as FormField[] | undefined) ?? []
  const ch = (content?.heading as string) ?? "Get in touch"
  const cbody = (content?.body as string) ?? ""
  const contactSectionClass = resolved.hasOverrides
    ? `px-4 @sm:px-6 @md:px-8 ${resolved.paddingClass || "py-8"} ${resolved.cornerClass} ${resolved.alignClass}`.trim()
    : "px-4 py-8 @sm:px-6 @md:px-8"
  const contactPrimaryColor = "var(--nos-color-primary, #3b82f6)"
  return (
    <section className={contactSectionClass} style={resolved.sectionStyle}>
      {org?.id ? (
        <ContactFormView
          orgId={org.id}
          sectionId={sectionId}
          fields={contactFields}
          heading={ch}
          body={cbody}
          submitLabel="Send message"
          primaryColor={contactPrimaryColor}
        />
      ) : (
        <>
          <h2 className="text-2xl font-bold mb-4" style={{ color: contactPrimaryColor }}>
            {ch}
          </h2>
          {cbody && <p className="mb-6 text-muted-foreground">{cbody}</p>}
          <p className="text-sm text-muted-foreground">Contact form (configure in website builder)</p>
        </>
      )}
    </section>
  )
}
